import { useContext } from 'react'
import { TeamShowContext } from '../contexts'

const useTeamShow = () => useContext(TeamShowContext)
export default useTeamShow
